import React, {useContext} from 'react';
import './DeliveryCaption.less';
import {ScheduleCaption} from 'elements/schedule-caption/ScheduleCaption';
import DeliveryIcon from 'new-images/delivery.svg';
import {convertPrice} from "helpers/format.helper";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const DeliveryCaption = ({time, price}) => {
	const translations = useContext(TranslationsContext);

	return (
		<ScheduleCaption
			text={price
				? getSafeTranslation('DeliveryCaption.timePriceTemplate', translations)
					.replace('{time}', time)
					.replace('{price}', convertPrice(price))
				: getSafeTranslation('DeliveryCaption.timeTemplate', translations)
					.replace('{time}', time)
			}
			icon={DeliveryIcon}
		/>
	);
};
